export default url => ({
  issuer: url,
  authorization_endpoint: `${url}/connect/authorize`,
  userinfo_endpoint: `${url}/connect/userinfo`,
  end_session_endpoint: `${url}/connect/endsession`,
  token_endpoint: `${url}/connect/token`,
  jwks_uri: `${url}/.well-known/openid-configuration/jwks`,
});
